var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.2392,
    y: 13.0392,
    width: 5.4902,
    height: 22.6471,
    rx: 1.37255,
    transform: "rotate(-90 6.2392 13.0392)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.20789,
    y: 21.2744,
    width: 5.4902,
    height: 22.6471,
    rx: 1.37255,
    transform: "rotate(-90 6.20789 21.2744)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.17645,
    y: 29.5097,
    width: 5.4902,
    height: 22.6471,
    rx: 1.37255,
    transform: "rotate(-90 6.17645 29.5097)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.686275,
    y: 0.686275,
    width: 33.6274,
    height: 33.6274,
    rx: 2.7451,
    stroke: "#D9D9D9",
    strokeWidth: 1.37255
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDisabled);
export default __webpack_public_path__ + "static/media/Table_Disabled.1483570bad41fe47ed9d70616df30b47.svg";
export { ForwardRef as ReactComponent };